import useRiskAssessmentHistoryAcknowledgementRecipients from "../../hooks/queries/useRiskAssessmentHistoryAcknowledgementRecipients";
import RiskAssessmentSharingProgress from "./RiskAssessmentSharingProgress";

// AcknowledgementStatus enum: Sent=0, Viewed=1, Acknowledged=2.
const ACKNOWLEDGED = 2;

// Per-occurrence acknowledged/total; fetches its own recipients (no bulk endpoint).
export default function RiskAssessmentHistorySharingCell({ riskAssessmentHistoryId }) {
    const { data, isLoading } = useRiskAssessmentHistoryAcknowledgementRecipients(riskAssessmentHistoryId);

    const recipients = Array.isArray(data) ? data : [];
    const total = recipients.length;
    const acknowledged = recipients.filter((r) => r.status === ACKNOWLEDGED).length;

    return <RiskAssessmentSharingProgress acknowledged={acknowledged} total={total} loading={isLoading} />;
}
